import { THEME_COLOR_KEYS, THEME_COLOR_DEFAULTS } from '../constants/themeColors'

const hexFromRgb = (value: string): string | null => {
  const match = value
    .replace(/\s+/g, '')
    .match(/^rgba?\((\d+),(\d+),(\d+)/i)
  if (!match) return null
  const r = Math.min(255, Math.max(0, Number(match[1])))
  const g = Math.min(255, Math.max(0, Number(match[2])))
  const b = Math.min(255, Math.max(0, Number(match[3])))
  const toHex = (n: number) => n.toString(16).padStart(2, '0')
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

export const normalizeColorForPicker = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return ''
  if (/^#([0-9a-f]{3}){1,2}$/i.test(trimmed)) {
    if (trimmed.length === 4) {
      return `#${trimmed[1]}${trimmed[1]}${trimmed[2]}${trimmed[2]}${trimmed[3]}${trimmed[3]}`
    }
    return trimmed
  }
  const rgbHex = hexFromRgb(trimmed)
  return rgbHex || ''
}

export const getThemeColorValue = (key: string): string => {
  if (typeof document === 'undefined') return THEME_COLOR_DEFAULTS[key] || ''
  const styles = getComputedStyle(document.documentElement)
  const value = styles.getPropertyValue(key).trim()
  return value || THEME_COLOR_DEFAULTS[key] || ''
}

export const getThemeColorValues = (): Record<string, string> => {
  return THEME_COLOR_KEYS.reduce<Record<string, string>>((acc, key) => {
    acc[key] = getThemeColorValue(key)
    return acc
  }, {})
}

export const applyThemeColorOverrides = (overrides: Record<string, string>) => {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  THEME_COLOR_KEYS.forEach((key) => {
    const value = overrides[key]
    if (value) {
      root.style.setProperty(key, value)
    } else {
      root.style.removeProperty(key)
    }
  })
}

export const clearThemeColorOverrides = () => {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  THEME_COLOR_KEYS.forEach((key) => {
    root.style.removeProperty(key)
  })
}

